// #region imports

// --- HS Code
import { FormatingTypes } from './formating-types';
import { StylesTeamRoleTypes } from '../my-development/styles-team-role-types';

// #endregion

export interface PinnedJournalEntryTextModel {
  id: string;
  pinnedJournalEntryId: string | null;
  styleId: number;
  pinLocation: string;
  resourceKey: string;
  index: number;
  stylesTeamRoleType: StylesTeamRoleTypes;
  isPinned: boolean;
  parentId: string;
  formatingType: FormatingTypes;
}
